// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"c6904982","629":"dfd4eb8b","908":"57b24bb5"}[chunkId] + ".chunk.css";
};